import { validateCheckoutRoute } from "./validate-checkout-route.js";
const getCheckoutPageInitialProps = async (ctx) => {
  const { query, apolloClient, pathname, res } = ctx;
  const { cartId, cartHash = "", type } = query || {};
  if (cartId) {
    if (!apolloClient) {
      console.error(`ApolloClient not present in context for page ${pathname}`);
    } else {
      const validationResult = await validateCheckoutRoute({
        apolloClient,
        cartHash,
        cartId,
        pathname,
        type
      });
      if (validationResult?.isCheckoutValid === false) {
        res?.writeHead(307, { Location: validationResult.redirectUrl });
        res?.end();
      }
    }
  }
  return {};
};
export {
  getCheckoutPageInitialProps
};
//# sourceMappingURL=get-checkout-page-initial-props.js.map
